webpackJsonp([42],{

/***/ 1034:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dictionary_form_remove_vue__ = __webpack_require__(952);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65313ca0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dictionary_form_remove_vue__ = __webpack_require__(1035);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dictionary_form_remove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65313ca0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dictionary_form_remove_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1035:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-sidebar',[_c('header',[_c('h2',[_vm._v("\n\t\t\t¿Está seguro que desea eliminar el dato \""+_vm._s(_vm.name)+"\"?\n\t\t")])]),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{on:{"cancel-button-clicked":function($event){return _vm.$emit('close-modal')},"accept-button-clicked":_vm.submitForm}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_action_bar_action_bar__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_reports_list_report_list__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_reports_list_report_list_asign__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_dictionary_dictionary_form_remove__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_app_button__ = __webpack_require__(248);




var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var templates, asignTemplates, uniqueArr;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.loadData('templates');

					case 2:
						templates = _context.sent;
						_context.next = 5;
						return this.loadData('company-template');

					case 5:
						asignTemplates = _context.sent;

						this.asignRow = asignTemplates.records;
						this.rows = templates.records;
						uniqueArr = this.rows.filter(function (item2) {
							return !_this.asignRow.some(function (item1) {
								return item1.code === item2.code;
							});
						});

						this.rows = uniqueArr;
						return _context.abrupt('return', this.rows);

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

var assignReport = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						body = {
							masterTemplateCodes: this.dataSelected.map(function (p) {
								return p.code;
							})
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.post('company-template-config', body);

					case 4:
						this.showNotification('Los reportes fueron asignados correctamente.');
						_context2.next = 7;
						return loadData.call(this);

					case 7:
						this.dataSelected = [];
						this.closeDialogReport();
						_context2.next = 14;
						break;

					case 11:
						_context2.prev = 11;
						_context2.t0 = _context2['catch'](1);

						if (_context2.t0.status === 400) {
							this.dialogReport = false;
							if (_context2.t0.data.message === 'TEMPLATE_EXIST') {
								this.showGenericError('El reporte ya asignado anteriormente.');
							}
						} else {
							this.showGenericError();
						}

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 11]]);
	}));

	return function assignReport() {
		return _ref2.apply(this, arguments);
	};
}();

var deleteTemplate = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return this.$http.delete('company-template/' + this.templateId);

					case 3:
						this.showNotification('El reporte fue eliminado correctamente.');
						_context3.next = 6;
						return loadData.call(this);

					case 6:
						this.action.visible = false;
						this.closeDialogDelete();
						_context3.next = 13;
						break;

					case 10:
						_context3.prev = 10;
						_context3.t0 = _context3['catch'](0);

						if (_context3.t0.status === 400) {
							this.dialogReport = false;
							if (_context3.t0.data.message === 'TEMPLATE_EXIST') {
								this.showGenericError('El reporte ya asignado anteriormente.');
							}
						} else {
							this.showGenericError();
						}

					case 13:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 10]]);
	}));

	return function deleteTemplate() {
		return _ref3.apply(this, arguments);
	};
}();

var created = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.next = 2;
						return loadData.call(this);

					case 2:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function created() {
		return _ref4.apply(this, arguments);
	};
}();

var onPage = function () {
	var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(page) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						this.params.page = page;
						_context5.next = 3;
						return loadData.call(this);

					case 3:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this);
	}));

	return function onPage(_x) {
		return _ref5.apply(this, arguments);
	};
}();

var onSearch = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(value) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						this.params.page = 1;
						this.$set(this.params, 'search', value || null);
						_context6.next = 4;
						return loadData.call(this);

					case 4:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this);
	}));

	return function onSearch(_x2) {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false
		},
		rows: [],
		asignRow: [],
		columns: [{ id: 1, name: 'Name', value: 'code', checked: true, visible: true }, {
			id: 2,
			name: 'Código',
			value: 'description',
			checked: true,
			visible: true
		}],
		limit: 10,
		checkAll: false,
		selectedRow: {
			id: null
		},
		dialogReport: false,
		dataSelected: [],
		templateId: null,
		dialogDelete: false
	};
}

function rowIsSelected() {
	this.checkAll = this.rows.every(function (r) {
		return r.isSelected;
	});
	this.dataSelected = this.rows.filter(function (r) {
		return r.isSelected;
	});
}

function onSelectedAll(checked) {
	this.checkAll = checked;
	this.rows = this.rows.map(function (row) {
		var newRow = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, row);
		newRow.isSelected = checked;
		return newRow;
	});
	this.dataSelected = this.rows.filter(function (r) {
		return r.isSelected;
	});
}

function onDelete(row) {
	this.templateId = row.id;
	this.dialogDelete = true;
}

function closeDialogReport() {
	this.dialogReport = false;
}

function closeDialogDelete() {
	this.dialogDelete = false;
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}
function actionsDisabled() {
	var disabledAction = this.dataSelected.length >= 1;
	return [{ code: 'asign-report-account', disabled: !disabledAction }];
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function moduleId() {
	return Number(this.$route.query.id);
}

function runAction(_ref7) {
	var name = _ref7.name,
	    code = _ref7.code;

	if (code === 'asign-report-account') {
		this.dialogReport = true;
	} else {
		this.action.title = name;
		this.action.code = code;
		this.action.visible = true;
	}
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function title() {
	return this.$route.query.name + ' / ' + this.$route.meta.title;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-templates',
	created: created,
	components: {
		actionBar: __WEBPACK_IMPORTED_MODULE_3__components_shared_action_bar_action_bar__["a" /* default */],
		actionSidebar: __WEBPACK_IMPORTED_MODULE_4__components_shared_action_sidebar__["a" /* default */],
		appButton: __WEBPACK_IMPORTED_MODULE_8__components_shared_app_button__["default"],
		reportListAsign: __WEBPACK_IMPORTED_MODULE_6__components_reports_list_report_list_asign__["a" /* default */],
		reportList: __WEBPACK_IMPORTED_MODULE_5__components_reports_list_report_list__["a" /* default */],
		dictionaryFormRemove: __WEBPACK_IMPORTED_MODULE_7__components_dictionary_dictionary_form_remove__["a" /* default */]
	},
	computed: {
		customerId: customerId,
		moduleId: moduleId,
		subsidiaryId: subsidiaryId,
		title: title,
		actionsDisabled: actionsDisabled
	},
	data: data,
	methods: {
		assignReport: assignReport,
		onSelectedAll: onSelectedAll,
		deleteTemplate: deleteTemplate,
		closeDialogDelete: closeDialogDelete,
		onDelete: onDelete,
		rowIsSelected: rowIsSelected,
		closeModal: closeModal,
		onPage: onPage,
		onSearch: onSearch,
		runAction: runAction,
		closeDialogReport: closeDialogReport
	}
});

/***/ }),

/***/ 1198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function actionsExist() {
	return this.columns.find(function (c) {
		return c.flagVisible;
	});
}

function allowEdit(_ref) {
	var flagEdit = _ref.flagEdit;

	return flagEdit ? 'Sí' : 'No';
}

function signLabel(_ref2) {
	var sign = _ref2.sign;

	return sign === 1 ? 'Debe' : 'Haber';
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'report-list',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	computed: {
		actionsExist: actionsExist
	},
	methods: {
		allowEdit: allowEdit,
		signLabel: signLabel
	},
	props: {
		checkAll: {
			default: false,
			type: Boolean
		},
		columns: {
			type: Array,
			required: true
		},
		currentPage: {
			type: Number,
			default: 1
		},
		isAssigned: {
			default: false,
			type: Boolean
		},
		lastPage: {
			type: Number,
			default: 0
		},
		rows: {
			type: Array,
			required: true
		}
	}
});

/***/ }),

/***/ 1199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function data() {
	return {
		columns: [{ id: 1, name: 'Nombre', value: 'code', checked: true, visible: true, movil: true }, { id: 2, name: 'Código', value: 'name', checked: true, visible: true }, { id: 5, name: 'Acciones', checked: true, visible: true, flagVisible: true }]
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'report-list-asign',
	components: {
		appTooltipButton: __WEBPACK_IMPORTED_MODULE_0__components_shared_app_tooltip_button__["a" /* default */]
	},
	data: data,
	props: {
		currentPage: {
			default: 1,
			type: Number
		},
		lastPage: {
			type: Number,
			default: 1
		},
		rows: {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	}
});

/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1507);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("4a6216e3", content, true, {});

/***/ }),

/***/ 1507:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.report-lista[data-v-64422e3d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/opt/build/repo/src/pages/company-templates/page-templates.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,+BAA+B,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,wBAAwB,qBAAqB,sBAAsB,CAC1P","file":"page-templates.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.report-lista[data-v-64422e3d]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_list_vue__ = __webpack_require__(1198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7599dd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_list_vue__ = __webpack_require__(1509);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7599dd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"mt-5",class:{ 'is-not-selectable' : _vm.isAssigned },attrs:{"name":"companies","filter-columns":false,"check-all":_vm.checkAll,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"columns":_vm.columns,"rows":_vm.rows,"selectable":!_vm.isAssigned},on:{"on-page":function($event){return _vm.$emit('on-page', $event)},"row-is-selected":function($event){return _vm.$emit('row-is-selected', $event)},"on-selected-all":function($event){return _vm.$emit('on-selected-all', $event)},"on-search-event":function($event){return _vm.$emit('on-search', $event)}},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{class:{ 'is-not-selectable' : _vm.isAssigned }},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.row.code))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_list_asign_vue__ = __webpack_require__(1199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c01f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_list_asign_vue__ = __webpack_require__(1513);
function injectStyle (ssrContext) {
  __webpack_require__(1511)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_list_asign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9c01f46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_list_asign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(721)("12c65d52", content, true, {});

/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(720)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:AvenirRegular;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}@media(max-width:768px){.col-1{background-color:#f2f2f2;display:grid;grid-column:1/4;grid-row:1;padding-left:33px!important;text-align:left!important;white-space:nowrap}}@media(max-width:768px){.col-2{border-top:1px solid #f2f2f2;grid-column:1/2;line-height:32px}}@media(max-width:768px){.col-2,.col-3{display:grid;grid-row:2}.col-3{grid-column:2/4}}@media(max-width:768px){.col-3,.col-4{text-align:center!important}.col-4{border-top:1px solid #f2f2f2;display:grid;grid-column:4/5;grid-row:2;padding-top:7px}}@media(max-width:800px){.col-5{background-color:#f2f2f2;display:grid;grid-column:4/5;grid-row:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.collapse-menu{display:none}@media(max-width:780px){.collapse-menu{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:block;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}}.collapse-menu .v-menu{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.collapse-menu .v-menu .v-btn{background-color:#33cfc7;height:25px;margin:0;width:25px}.menu-content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:AvenirRegular;font-size:12px!important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px}.menu-content .factory{color:#006edb}.menu-content .edit{color:#33cfc7}.btn-menu-content{border-bottom:1px solid #e5eaef}", "", {"version":3,"sources":["/opt/build/repo/src/components/reports-list/report-list-asign.vue"],"names":[],"mappings":"AACA,WAAW,0BAA4B,6DAA6D,gBAAmB,kBAAkB,iBAAiB,CACzJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,uBAAyB,0DAA0D,gBAAmB,kBAAkB,iBAAiB,CACnJ,AACD,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,wBACA,OAAO,yBAAyB,aAAa,gBAAgB,WAAW,4BAA6B,0BAA2B,kBAAkB,CACjJ,CACA,AACD,wBACA,OAAO,6BAA6B,AAAa,gBAAgB,AAAW,gBAAgB,CAC3F,CACA,AACD,wBACA,cAJoC,aAAa,AAAgB,UAAW,CAK3E,AADD,OAAoB,eAAgB,CACnC,CACA,AACD,wBACA,cAJ+C,2BAA4B,CAK1E,AADD,OAAO,6BAA6B,aAAa,gBAAgB,WAAW,eAAgB,CAC3F,CACA,AACD,wBACA,OAAO,yBAAyB,aAAa,gBAAgB,WAAW,wBAAwB,qBAAqB,sBAAsB,CAC1I,CACA,AACD,eAAe,YAAY,CAC1B,AACD,wBACA,eAAe,yBAAyB,sBAAsB,mBAAmB,cAAc,YAAY,wBAAwB,qBAAqB,sBAAsB,CAC7K,CACA,AACD,uBAAuB,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,sBAAsB,CAC5N,AACD,8BAA8B,yBAAyB,YAAY,SAAS,UAAU,CACrF,AACD,cAAc,yBAAyB,sBAAsB,mBAAmB,cAAc,aAAa,0BAA4B,yBAA0B,oBAAoB,+BAA+B,WAAW,CAC9N,AACD,uBAAuB,aAAa,CACnC,AACD,oBAAoB,aAAa,CAChC,AACD,kBAAkB,+BAA+B,CAChD","file":"report-list-asign.vue","sourcesContent":["\n@font-face{font-family:\"AvenirRegular\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirBold\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"AvenirDemi\";src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:normal;font-display:swap;font-style:normal\n}\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n@media(max-width: 768px){\n.col-1{background-color:#f2f2f2;display:grid;grid-column:1/4;grid-row:1;padding-left:33px !important;text-align:left !important;white-space:nowrap\n}\n}\n@media(max-width: 768px){\n.col-2{border-top:1px solid #f2f2f2;display:grid;grid-column:1/2;grid-row:2;line-height:32px\n}\n}\n@media(max-width: 768px){\n.col-3{display:grid;grid-column:2/4;grid-row:2;text-align:center !important\n}\n}\n@media(max-width: 768px){\n.col-4{border-top:1px solid #f2f2f2;display:grid;grid-column:4/5;grid-row:2;padding-top:7px;text-align:center !important\n}\n}\n@media(max-width: 800px){\n.col-5{background-color:#f2f2f2;display:grid;grid-column:4/5;grid-row:1;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n.collapse-menu{display:none\n}\n@media(max-width: 780px){\n.collapse-menu{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:block;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n}\n.collapse-menu .v-menu{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.collapse-menu .v-menu .v-btn{background-color:#33cfc7;height:25px;margin:0;width:25px\n}\n.menu-content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#f52c18;display:grid;font-family:\"AvenirRegular\";font-size:12px !important;grid-column-gap:3px;grid-template-columns:15px 1fr;width:175px\n}\n.menu-content .factory{color:#006edb\n}\n.menu-content .edit{color:#33cfc7\n}\n.btn-menu-content{border-bottom:1px solid #e5eaef\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-table',{staticClass:"is-not-selectable",attrs:{"name":"dictionary","columns":_vm.columns,"current-page":_vm.currentPage,"last-page":_vm.lastPage,"rows":_vm.rows},on:{"on-search-event":function($event){return _vm.$emit('on-search', $event)},"on-page":function($event){return _vm.$emit('on-page', $event)}},scopedSlots:_vm._u([{key:"rows",fn:function(props){return [_c('td',{staticClass:"is-not-selectable col-1"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.name)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"col-2"},[_vm._v("\n\t\t\t\t"+_vm._s(props.row.code)+"\n\t\t\t")]),_vm._v(" "),_c('td',{staticClass:"col-5"},[_c('app-tooltip-button',{staticClass:"no-movil",attrs:{"color":"error","img":"/static/img/actions-list/delete.svg","text":"Eliminar"},on:{"click-icon":function($event){return _vm.$emit('on-delete', props.row)}}}),_vm._v(" "),_c('div',{staticClass:"collapse-menu"},[_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","dark":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_horiz")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"btn-menu-content"},[_c('v-list-tile',{staticClass:"menu-content",on:{"click":function($event){return _vm.$emit('on-delete', props.row)}}},[_c('img',{staticClass:"menu-option-icon",attrs:{"src":"/static/img/actions-list/delete.svg","alt":"delete","width":"15px","height":"15px"}}),_vm._v(" "),_c('span',{staticClass:"ml-1"},[_vm._v("Eliminar")])])],1)],1)],1)],1)],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1514:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-templates"},[_c('header-page',{attrs:{"actions":"","name":"apage-templates","title":_vm.title},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('v-layout',{staticClass:"report-lista",attrs:{"row":"","align-end":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('report-list',{attrs:{"check-all":_vm.checkAll,"columns":_vm.columns,"current-page":_vm.params.page,"last-page":_vm.table.lastPage,"rows":_vm.rows},on:{"click-icon":_vm.clickIcon,"on-page":_vm.onPage,"on-search":_vm.onSearch,"on-selected-all":_vm.onSelectedAll,"row-is-selected":_vm.rowIsSelected}})],1)],1),_vm._v(" "),_c('action-bar',{staticClass:"action-mobile",attrs:{"value-disabled":_vm.actionsDisabled,"resource-uri":_vm.$route.name},on:{"run-action":_vm.runAction}}),_vm._v(" "),_c('action-sidebar',{attrs:{"title":_vm.action.title,"value":_vm.action.visible},on:{"close-modal":_vm.closeModal}},[_c('v-layout',{staticClass:"report-lista",attrs:{"row":"","align-end":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('report-list-asign',{attrs:{"current-page":_vm.params.page,"last-page":_vm.table.lastPage,"rows":_vm.asignRow},on:{"click-icon":_vm.clickIcon,"on-delete":_vm.onDelete,"on-page":_vm.onPage,"on-search":_vm.onSearch}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"333"},model:{value:(_vm.dialogReport),callback:function ($$v) {_vm.dialogReport=$$v},expression:"dialogReport"}},[_c('v-card',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-flex',{staticClass:"text-dialog",attrs:{"pb-4":"","pt-2":"","text-xs-center":""}},[_vm._v("\n\t\t\t\t\t¿Estas seguro que desea\n\t\t\t\t\t"+_vm._s(_vm.dataSelected.length > 1
							? 'asignar los reportes'
							: 'asignar el reporte')+"\n\t\t\t\t\t?\n\t\t\t\t")])],1),_vm._v(" "),_c('v-card-actions',{staticClass:"background-dialog",attrs:{"pa-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","ma-0":"","pa-1":""}},[_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"#ff002b","small":""},on:{"click":_vm.closeDialogReport}},[_vm._v("NO")]),_vm._v(" "),_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"teal darken-1","small":""},on:{"click":_vm.assignReport}},[_vm._v("SI")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"333"},model:{value:(_vm.dialogDelete),callback:function ($$v) {_vm.dialogDelete=$$v},expression:"dialogDelete"}},[_c('v-card',[_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-flex',{staticClass:"text-dialog",attrs:{"pb-4":"","pt-2":"","text-xs-center":""}},[_vm._v("\n\t\t\t\t\t¿Estas seguro que deseas eliminar este Template\n\t\t\t\t\t?\n\t\t\t\t")])],1),_vm._v(" "),_c('v-card-actions',{staticClass:"background-dialog",attrs:{"pa-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","ma-0":"","pa-1":""}},[_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"#ff002b","small":""},on:{"click":_vm.closeDialogDelete}},[_vm._v("NO")]),_vm._v(" "),_c('v-btn',{style:("color: #fff !important"),attrs:{"color":"teal darken-1","small":""},on:{"click":_vm.deleteTemplate}},[_vm._v("SI")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 753:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_templates_vue__ = __webpack_require__(1197);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64422e3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_templates_vue__ = __webpack_require__(1514);
function injectStyle (ssrContext) {
  __webpack_require__(1506)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64422e3d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_templates_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64422e3d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_templates_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var submitForm = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return this.$http.delete('data-dictionary/' + this.id);

					case 3:
						this.$emit('close-modal', true);
						this.showNotification('Dato eliminado correctamente');
						_context.next = 10;
						break;

					case 7:
						_context.prev = 7;
						_context.t0 = _context['catch'](0);

						this.showGenericError();

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 7]]);
	}));

	return function submitForm() {
		return _ref.apply(this, arguments);
	};
}();

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'dictionary-remove',
	methods: {
		submitForm: submitForm
	},
	props: {
		id: {
			type: Number,
			default: null
		},
		name: {
			type: String,
			required: true
		}
	}
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.4d70803276f485dc7673.js